import '../styles/global.css';
import '../styles/responsive.css';
import Redirect from './Redirect';

function App() {
  return (
    <Redirect/>
  );
}

export default App;
